export default class VehicleManufacturer {
    constructor(data?: any) {
        if (data) {
            this.id = data.id;
            this.date = data.date;
            this.name = data.name;
            this.description = data.description;
            this.logo = data.logo;
        }
    }

    id = 0;
    date = new Date(1970,0,1);
    name = '';
    description: string | null = null;
    /** manufacturer's (brand) logo filename */
    logo: string | null = null;
}
